import { createFileRoute, Outlet } from '@tanstack/react-router'
import { PublicFooter } from '@/components/PublicFooter'
import { PublicHeader } from '@/components/PublicHeader'

export const Route = createFileRoute('/link/$parentId')({
  component: ParentLayout,
})

function ParentLayout() {
  return (
    <div className="min-h-screen flex flex-col">
      <PublicHeader />
      <Outlet />
      <PublicFooter />
    </div>
  )
}
